import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.map";
import _upperCase from "lodash/upperCase";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createAction } from 'redux-act';
import { createAsyncAction } from "./utils";
import { CONFIRM_FDP_OPT_IN, DISMISS_FDP_OPT_IN, GET_FDP_OPT_IN_STATE, GET_PORTAL_BY_INSTITUTION_ID_QUERY, INITIALIZE_PORTAL_QUERY, NOTIFY_PLAID_LINK_EVENT_MUTATION, NOTIFY_SUCCESSFUL_PLAID_LINK_MUTATION, REINITIALIZE_FINANCIAL_PORTAL_MUTATION } from "../lib/queries/financial-data";
export var RESET_PLAID_ONBOARDING = 'RESET_PLAID_ONBOARDING';
export var resetPlaidOnboarding = function resetPlaidOnboarding() {
  return {
    type: RESET_PLAID_ONBOARDING
  };
};
/**
 * @deprecated this feature is no longer in use
 */

export var SET_IS_FDP_OPT_IN_ENABLED_ACTION = 'SET_IS_FDP_OPT_IN_ENABLED';
/**
 * @deprecated this feature is no longer in use
 * @param {bool} isEnabled - The value to set the flag
 */

export var setIsFdpOptInEnabled = function setIsFdpOptInEnabled(isEnabled) {
  return {
    type: SET_IS_FDP_OPT_IN_ENABLED_ACTION,
    isEnabled: isEnabled
  };
};
/**
 * Given a marketplace account aggregation institution id, return the associated portal for the currently
 * logged in user.
 */

export var getPortalForInstitution = createAsyncAction('getPortalForInstitution', function (_ref) {
  var marketplaceInstitutionId = _ref.marketplaceInstitutionId;
  return {
    makeRequest: function makeRequest(state, _ref2) {
      var apolloClient = _ref2.apolloClient;
      return apolloClient.query({
        query: GET_PORTAL_BY_INSTITUTION_ID_QUERY,
        variables: {
          marketplaceInstitutionId: marketplaceInstitutionId
        },
        fetchPolicy: 'network-only'
      });
    },
    meta: {
      marketplaceInstitutionId: marketplaceInstitutionId
    }
  };
});
/**
 * Given a marketplace account aggregation institution id, create a portal for the
 * user x institution combo.
 */

export var initializePortal = createAsyncAction('initializePortal', function (_ref3) {
  var marketplaceInstitutionId = _ref3.marketplaceInstitutionId;
  return {
    makeRequest: function makeRequest(state, _ref4) {
      var apolloClient = _ref4.apolloClient;
      return apolloClient.query({
        query: INITIALIZE_PORTAL_QUERY,
        variables: {
          marketplaceInstitutionId: marketplaceInstitutionId
        },
        fetchPolicy: 'network-only'
      });
    },
    meta: {
      marketplaceInstitutionId: marketplaceInstitutionId
    }
  };
});
export var reinitializePortal = createAsyncAction('reinitializePortal', function (financialPortalId) {
  return {
    makeRequest: function makeRequest(state, _ref5) {
      var apolloClient = _ref5.apolloClient;
      return apolloClient.mutate({
        mutation: REINITIALIZE_FINANCIAL_PORTAL_MUTATION,
        variables: {
          financialPortalId: financialPortalId
        },
        fetchPolicy: 'no-cache'
      });
    },
    meta: {
      financialPortalId: financialPortalId
    }
  };
});
export var notifySuccessfulPlaidLink = createAsyncAction('notifySuccessfulPlaidLink', function (financialPortalId, publicToken, metadata, webhook) {
  return {
    makeRequest: function makeRequest(state, _ref6) {
      var apolloClient = _ref6.apolloClient;
      // need to camelCase institutionId
      var institution = {
        name: _get(metadata, 'institution.name'),
        institutionId: _get(metadata, 'institution.institution_id')
      };
      var accounts = (_get(metadata, 'accounts') || []).map(function (acct) {
        return _objectSpread(_objectSpread({}, acct), {}, {
          // query0 enums are always uppercase
          subtype: _upperCase(acct.subtype),
          type: _upperCase(acct.type),
          verificationStatus: acct.verificationStatus ? _upperCase(acct.verificationStatus) : null
        });
      });
      var variables = {
        accounts: accounts,
        financialPortalId: financialPortalId,
        institution: institution,
        publicToken: publicToken,
        webhook: webhook
      };
      return apolloClient.mutate({
        mutation: NOTIFY_SUCCESSFUL_PLAID_LINK_MUTATION,
        variables: variables,
        fetchPolicy: 'no-cache'
      });
    },
    meta: {
      publicToken: publicToken
    }
  };
});
export var publishLinkEvent = createAsyncAction('publishLinkEvent', function (event, eventBody, financialPortalId, sourceEntityId) {
  return {
    makeRequest: function makeRequest(state, _ref7) {
      var apolloClient = _ref7.apolloClient;
      var variables = {
        event: event,
        eventBody: eventBody,
        financialPortalId: financialPortalId,
        sourceEntityId: sourceEntityId
      };
      return apolloClient.mutate({
        mutation: NOTIFY_PLAID_LINK_EVENT_MUTATION,
        variables: variables,
        fetchPolicy: 'no-cache'
      });
    },
    meta: {
      event: event,
      financialPortalId: financialPortalId
    }
  };
});
/**
 * @deprecated this feature is no longer in use
 */

export var fetchFdpOptInState = createAsyncAction('fetchFdpOptInState', function () {
  return {
    makeRequest: function makeRequest(state, _ref8) {
      var apolloClient = _ref8.apolloClient;
      return apolloClient.query({
        query: GET_FDP_OPT_IN_STATE,
        fetchPolicy: 'no-cache'
      });
    }
  };
});
/**
 * @deprecated this feature is no longer in use
 */

export var dismissFdpOptIn = createAsyncAction('dismissFdpOptIn', function () {
  return {
    makeRequest: function makeRequest(state, _ref9) {
      var apolloClient = _ref9.apolloClient;
      return apolloClient.mutate({
        mutation: DISMISS_FDP_OPT_IN
      });
    }
  };
});
/**
 * @deprecated this feature is no longer in use
 */

export var confirmFdpOptIn = createAsyncAction('confirmFdpOptIn', function () {
  return {
    makeRequest: function makeRequest(state, _ref10) {
      var apolloClient = _ref10.apolloClient;
      return apolloClient.mutate({
        mutation: CONFIRM_FDP_OPT_IN
      });
    }
  };
});
export var startRelink = createAction('startRelink');
export var chooseUnavailableProvider = createAction('chooseUnavailableProvider');